import { db } from '../components/Dexie';
import { log } from './loggingService';

/**
 * Sincronizza i menu con l'API remota.
 * @param {boolean} force - Se true, cancella i dati locali e forza un sync completo.
 * @returns {Promise<{success: boolean, message: string}>}
 */
export const syncTechyShopMenu = async (force = true) => {
  try {
    if (force) {
      log("Reset menu techyshop locali in corso...", 'INFO');
      await db.techyshop_menu.clear();
    }
    
    log("Avvio download menu dal server...", 'INFO');

    const response = await fetch('https://deadapi.techysumo.it/techyshop/listMenu', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // Utilizziamo la stessa chiave API degli altri servizi
        'Authorization': process.env.REACT_APP_API_KEY || '12345', 
      },
      body: JSON.stringify({})
    });
    
    const result = await response.json();
    
    if (result.result && Array.isArray(result.details)) {
      const normalizedMenus = result.details.map(m => ({
        ...m,
        id: isNaN(parseInt(m.id)) ? m.id : parseInt(m.id),
        enable: (m.enable == 1 || m.enable === true || String(m.enable).toLowerCase() === 'true') ? 1 : 0
      }));
      
      await db.techyshop_menu.bulkPut(normalizedMenus);
      log(`Sincronizzati ${normalizedMenus.length} menu.`, 'INFO');

      return { success: true, message: `Sincronizzati ${normalizedMenus.length} menu con successo!` };
    } else {
      throw new Error(result.text || "Errore durante il download dei menu.");
    }
  } catch (error) {
    log("Errore durante la sincronizzazione dei menu:", 'ERROR', error);
    return { success: false, message: `Errore: ${error.message}` };
  }
};
